import styled from 'styled-components';

const StyledLink = styled.a`
  color: #f4c064 !important;
`;

const heroContentLoggedOut = {
  title: 'Earn money by renting out your boat.',
  tag: (
    <span>
      This information will help us identify the rest of your boat details, which you can review later. Want to make
      sure your boat is eligible before starting? Learn more{' '}
      <StyledLink
        target="_blank"
        href="https://support.boatsetter.com/hc/en-us/articles/205919570-Information-required-for-boat-approval"
      >
        here
      </StyledLink>
      .
    </span>
  ),
};

const heroContentLoggedIn = {
  title: 'Tell us a little about your boat',
  tag: (
    <span>
      This information will help us identify the rest of your boat details, which you can review later. Want to make
      sure your boat is eligible before starting? Learn more{' '}
      <StyledLink
        target="_blank"
        href="https://support.boatsetter.com/hc/en-us/articles/205919570-Information-required-for-boat-approval"
      >
        here
      </StyledLink>
      .
    </span>
  ),
};

const Hero = (props) => {
  const { isAuthenticated } = props;
  const heroContent = isAuthenticated ? heroContentLoggedIn : heroContentLoggedOut;
  const { title, tag } = heroContent;

  return (
    <div
      className={`u-md-phz2 u-md-pt3 u-md-mb3 u-sm-phz1 ${
        !isAuthenticated ? 'u-sm-pb16 u-md-pb16' : 'u-sm-pb20 u-md-pb20  u-lg-pr7'
      } u-sm-mb0 u-sm-mt0 u-sm-pt0 u-sm-pb0 u-mt1_5 u-sm-pt1`}
    >
      <h1 className="u-fsXxxl u-sm-fsXmm u-textWhite u-textSemiBold u-mb05">{title}</h1>
      <p className={`u-textWhite ${isAuthenticated ? 'u-lg-pr7' : ''} `}>{tag}</p>
    </div>
  );
};

export default Hero;
